<script setup lang="ts">
  withDefaults(
    defineProps<{
      text: string;
      muted?: boolean;
      bold?: boolean;
    }>(),
    {
      bold: true,
    },
  );
</script>

<template>
  <span
    :class="muted ? 'text-gray-xx-02' : ['text-gray-07 text-sm', bold ? 'font-semibold' : 'font-normal']"
  >
    {{ text }}
  </span>
</template>
